'use client'
import React, {useEffect, useState} from 'react'
import {
  NavbarItem,
  PopoverContent,
  Popover,
  PopoverTrigger,
  NavbarContent,
} from '@heroui/react'
import Link from 'next/link'
import {usePathname} from 'next/navigation'

import Box from '@/components/UI/Box/Box'
import Grid from '@/components/UI/Grid/Grid'
import {Body5} from '@/components/UI/Typography'

import {useDebouncedCallback} from '../../src/shared/utils/useDebounce'
import megaMenuContent from './constants'

import {cn} from '@/src/shared/utils/twMerge'

const NavMegaMenu = () => {
  const [selectedMenuId, setSelectedMenuId] = useState(-1)
  const [isEnterPopover, setIsEnterPopover] = useState(false)
  const [isOpenPopover, setIsOpenPopover] = useState(false)
  const pathname = usePathname()

  const onMenuHover = useDebouncedCallback((id: number) => {
    setSelectedMenuId(id)
  }, 300)

  const onLeavePopover = useDebouncedCallback(() => {
    setIsEnterPopover(false)
    setSelectedMenuId(-1)
  }, 300)

  const onSetPopoverOpen = useDebouncedCallback((open: boolean) => {
    setIsOpenPopover(open)
  }, 300)

  useEffect(() => {
    setIsOpenPopover(false)
    setIsEnterPopover(false)
    setSelectedMenuId(-1)
  }, [pathname])

  const megaMenuRenderer = () => {
    if (selectedMenuId === 0) {
      return (
        <Grid container>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu0.column0}
          </Grid>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu0.column1}
          </Grid>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu0.column2}
          </Grid>
        </Grid>
      )
    } else if (selectedMenuId === 1) {
      return (
        <Grid container>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu1.column0}
          </Grid>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu1.column1}
          </Grid>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu1.column2}
          </Grid>
        </Grid>
      )
    } else if (selectedMenuId === 2) {
      return (
        <Grid container>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu2.column0}
          </Grid>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu2.column1}
          </Grid>
          <Grid className="flex flex-col col-span-4">
            {megaMenuContent.menu2.column2}
          </Grid>
        </Grid>
      )
    }
    return null
  }

  return (
    <>
      <Box className="gap-16 justify-center h-full items-center">
        <NavbarContent className="flex h-full items-center gap-0 w-fit !grow-0">
          <NavbarItem
            className="px-8 h-full flex items-center"
            onMouseEnter={() => {
              onMenuHover(0)
              onSetPopoverOpen(true)
            }}
            onMouseLeave={() => {
              onSetPopoverOpen(false)
              onMenuHover(-1)
            }}>
            <Body5
              className={cn(
                'cursor-default font-medium pb-[1px]',
                selectedMenuId === 0 &&
                  'text-primary border-b-1 border-primary pb-0'
              )}>
              KENDİM İÇİN
            </Body5>
          </NavbarItem>
          <NavbarItem
            className="px-8 h-full flex items-center"
            onMouseEnter={() => {
              onMenuHover(1)
              onSetPopoverOpen(true)
            }}
            onMouseLeave={() => {
              onSetPopoverOpen(false)
              onMenuHover(-1)
            }}>
            <Body5
              className={cn(
                'cursor-default font-medium pb-[1px]',
                selectedMenuId === 1 &&
                  'text-primary border-b-1 border-primary pb-0'
              )}>
              ÇOCUK VE ANNE
            </Body5>
          </NavbarItem>
          <NavbarItem
            className="px-8 h-full flex items-center"
            onMouseEnter={() => {
              onMenuHover(2)
              onSetPopoverOpen(true)
            }}
            onMouseLeave={() => {
              onSetPopoverOpen(false)
              onMenuHover(-1)
            }}>
            <Body5
              className={cn(
                'cursor-default font-medium pb-[1px]',
                selectedMenuId === 2 &&
                  'text-primary border-b-1 border-primary pb-0'
              )}>
              İŞİM İÇİN
            </Body5>
          </NavbarItem>
        </NavbarContent>
        <NavbarContent className="flex h-full items-center gap-16 w-fit !grow-0">
          <NavbarItem>
            <Link href="/blog" className="text-gray-400">
              Blog
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link href="/rehber" className="text-gray-400">
              Rehber
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link href="/nasil-calisiyor" className="text-gray-400">
              Nasıl Çalışıyor?
            </Link>
          </NavbarItem>
        </NavbarContent>
      </Box>
      <Popover
        placement="bottom"
        classNames={{
          backdrop: 'top-40',
        }}
        offset={0}
        backdrop="blur"
        isOpen={isOpenPopover || isEnterPopover}>
        <PopoverTrigger
          role="button"
          aria-label="Popover trigger"
          className="absolute left-1/2 -translate-x-1/2">
          <div className="w-0 h-0" />
        </PopoverTrigger>
        <PopoverContent
          onMouseEnter={() => {
            onMenuHover(selectedMenuId)
            setIsEnterPopover(true)
          }}
          onMouseLeave={onLeavePopover}
          className="w-[800px] shadow-none backdrop-filter-none rounded-t-none border-t-1 overflow-hidden p-6">
          {megaMenuRenderer()}
        </PopoverContent>
      </Popover>
    </>
  )
}

export default NavMegaMenu
